// File: src/components/WebsiteTour/QuestionListFiltersTour.jsx

import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const QuestionListFiltersTour = ({ autoStart = true, onComplete }) => {
  const { startTour } = useShepherdTour(
    'question_list_filters', 
    TOUR_DATA.question_list_filters.steps, 
    autoStart, 
    onComplete
  );

  return null;
};

export default QuestionListFiltersTour;
